import React from 'react';
import { CalendarDays } from 'lucide-react';
import { useAuth } from '../../auth';
import { ProfileAvatar } from './ProfileAvatar';
import { AvatarEditor } from './AvatarEditor';
import { RoleBadge } from '../chat/AdminBadge';

export const AccountIdentityHeader = ({ editable }) => {
  const { user } = useAuth();
  if (!user) return null;
  const date = user.created_at ? new Date(user.created_at) : null;
  const valid = date && !Number.isNaN(date.getTime());
  const joined = valid ? date.toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric', timeZone: 'UTC' }) : 'Not available';
  const identity = <div className="account-identity-copy">
    <h2 data-testid="account-identity-name"><span>{user.username}</span><RoleBadge role={user.role} testid="account-identity-role-badge" /></h2>
    <p><CalendarDays size={14} aria-hidden="true" />Joined on <time data-testid="account-identity-joined" dateTime={valid ? user.created_at : undefined}>{joined}</time></p>
  </div>;
  return <section id={editable ? 'profile-picture' : undefined} className="account-identity-container" data-testid="account-identity-header" aria-label="Your profile">
    {editable ? <AvatarEditor>{identity}</AvatarEditor> : <div className="account-identity-static"><ProfileAvatar avatarId={user.avatar_id} name={user.username} size={96} testid="account-identity-avatar" />{identity}</div>}
  </section>;
};